// extracted by mini-css-extract-plugin
export default {"subnav":"subnav_subnav__A5HlR","taskdropdown":"subnav_taskdropdown__jakA4","pagination":"subnav_pagination__eeLmr"};